var context = require.context("./views/mixins", true, /\.js$/);
context.keys().forEach( function(key) {
  context(key);
});

require('./views/application.js');
require('./views/block.js');
require('./views/fragment.js');
require('./views/payload.js');
require('./views/scroll_region.js');

var context = require.context("./views/patches", true, /\.js$/);
context.keys().forEach( function(key) {
  context(key);
});


var context = require.context("./views/controls", true, /\.js$/);
context.keys().forEach( function(key) {
  context(key);
});

var context = require.context("./views/template", true, /\.js$/);
context.keys().forEach( function(key) {
  context(key);
});
